module.exports = __webpack_public_path__ + "img/hexin1.8166f349.jpg";